export default __webpack_public_path__ + "static/1104-24290c427f8f544a4714bc58074ad975.gif";